import React, { PropTypes } from 'react';
import { Field, initialize, reduxForm, reset, SubmissionError } from 'redux-form';
import RenderField from '../../../../FormTemplate/InputControl';
import SelectAsync from '../../../../FormTemplate/SelectAsync';
import Select from '../../../../FormTemplate/Select';
import RenderTextArea from '../../../../FormTemplate/TextareaControl';
import { Button } from 'react-bootstrap';
import axios from './../../../../../constants/axios';
import alert from 'alertify.js';

@reduxForm({
   form: 'productMainEditGeneralInfoForm'
})
class ProductMainEditGeneralInfoForm extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         generalInfo: {}
      };
   }

   componentDidMount() {
      const { productId } = this.props.params;
      return axios
         .get(`items/productMain/getGeneralInfoById/${productId}`)
         .then((res) => {
            this.props.dispatch(initialize('productMainEditGeneralInfoForm', res.data, true));
            this.setState({
               generalInfo: res.data
            });
         });
   }

   updateGeneralInfo = (generalInfo) => {
      const { productId } = this.props.params;
      const data = Object.assign({}, generalInfo, {
         id: productId
      });
      return axios.post('items/productMain/updateGeneralInfo', data)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Product Updated.');
               this.props.dispatch(initialize('productMainEditGeneralInfoForm', data, true));
               this.props.dispatch(reset('productMainEditGeneralInfoForm'));
               this.setState({
                  generalInfo: data
               });
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };

   render() {
      const { handleSubmit, submitting, invalid } = this.props;
      const { generalInfo } = this.state;
      return (
         <div >
            <h3 >Product Name: {generalInfo.name}</h3 >
            <hr />
            <form noValidate autoComplete="off" onSubmit={handleSubmit(this.updateGeneralInfo)} >
               <h4 >Product General Information</h4 >
               <hr />
               <Field name="name" component={RenderField} type="text" label="Product Name" />
               <Field name="has_sub_items" component="input" type="hidden" />
               {generalInfo.has_sub_items === 0 &&
               <Field name="barcode" component={RenderField} type="text" label="Barcode" />
               }
               <Field name="description" component={RenderTextArea} rows="7" label="Product Description" />
               <Field name="net_weight" component={RenderField} type="number" label="Net Weight (gm)" />
               <Field name="brand_id"
                      component={SelectAsync}
                      initial={[
                         { label: generalInfo.brand_name, value: generalInfo.brand_id }
                      ]}
                      link="brands/searchByName" label="Brand Name" />
               <Field name="made_in_country_id"
                      component={SelectAsync}
                      initial={[
                         { label: generalInfo.made_in_country_name, value: generalInfo.made_in_country_id }
                      ]}
                      link="countries/searchByName" label="Made In Country" />

               <Field name="active" component={Select}
                      options={[{ value: 1, label: "Active" }, { value: 0, label: "In Active" }]}
                      label="Active / InActive" />
               <Field name="showOnSite" component={Select}
                      options={[{ value: 1, label: "Show" }, { value: 0, label: "Hide" }]}
                      label="Show On Site" />
               <Button type="submit" bsStyle="success" block
                       disabled={submitting || invalid} >Update</Button >
            </form >
         </div >
      );
   }
}

ProductMainEditGeneralInfoForm.propTypes = {
   handleSubmit: PropTypes.func,
   params: PropTypes.object,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   dispatch: PropTypes.func
};


export default ProductMainEditGeneralInfoForm;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainEditGeneralInfoForm.js
 **/